export default __webpack_public_path__ + "static/media/x-telegram.c5f59219.svg";